export const THINGS_TO_DO_RECENT_SEARCHES_KEY = "things_to_do_recent_searches";
export const THINGS_TO_DO_RECENT_VIEWED_KEY = "things_to_do_recent_viewed";

const rawThingsToDoListings = [
  {
    id: "tokyo-disneyland",
    title: "Tokyo Disneyland 1-Day Passport",
    description: "Enjoy a magical day with family-friendly rides, parades, and themed entertainment.",
    category: "Attractions",
    location: "Tokyo, Japan",
    country: "Japan",
    rating: 4.8,
    purchaseCount: 12450,
    tags: ["Instant confirmation", "Best seller"],
    images: [
      "https://images.unsplash.com/photo-1505764706515-aa95265c5abc?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1519677100203-a0e668c92439?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1513883049090-d0b7439799bf?auto=format&fit=crop&w=1200&q=80",
    ],
    highlights: [
      "Access iconic rides and live shows throughout the day",
      "Flexible park entry with easy mobile voucher redemption",
      "Great option for families, couples, and first-time visitors",
    ],
    bookingDetails: {
      terms: ["Non-refundable after confirmation", "Valid only on selected date"],
      howToUse: ["Present QR code at entry gate", "Bring valid photo ID"],
    },
    whatToExpect: {
      description:
        "Explore themed lands, seasonal events, and parades. Food and shopping options are available across the park.",
      itinerary: ["Park entry", "Rides and attractions", "Parade and night show"],
      inclusions: ["Park admission", "Selected seasonal access"],
      exclusions: ["Meals", "Transport"],
      meetingPoint: "Main gate, Tokyo Disneyland",
    },
    operator: {
      name: "Tokyo Theme Parks Co.",
      location: "1-1 Maihama, Urayasu",
    },
    reviews: [
      { user: "Alicia", rating: 5, comment: "Smooth entry and amazing experience." },
      { user: "Noah", rating: 4, comment: "Lots to do, recommend arriving early." },
    ],
    faqs: [
      { question: "Can I re-enter the park?", answer: "Re-entry follows current park policy and ticket type." },
      { question: "Are child tickets required?", answer: "Yes, children need a valid child ticket based on age bands." },
    ],
    packages: [
      {
        name: "Standard",
        skus: [
          {
            id: "tdl-standard-open",
            title: "Open-Dated Admission",
            price_adult: 95,
            price_child: 72,
            available_dates: [],
            capacity: 200,
          },
          {
            id: "tdl-standard-date",
            title: "Date-Specific Admission",
            price_adult: 88,
            price_child: 66,
            available_dates: ["2026-04-12", "2026-04-13", "2026-04-15", "2026-04-20"],
            capacity: 120,
          },
        ],
      },
      {
        name: "VIP",
        skus: [
          {
            id: "tdl-vip-fastpass",
            title: "VIP Entry + Priority Access",
            price_adult: 160,
            price_child: 130,
            available_dates: ["2026-04-13", "2026-04-15"],
            capacity: 40,
          },
        ],
      },
    ],
  },
  {
    id: "bali-private-charter",
    title: "Bali Private Charter with Driver",
    description: "Customize your own route with a private charter and local driver.",
    category: "Private Charter",
    location: "Bali, Indonesia",
    country: "Indonesia",
    rating: 4.7,
    purchaseCount: 5280,
    tags: ["Free cancellation", "Hotel pickup"],
    images: [
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1520483601560-389dff434fdf?auto=format&fit=crop&w=1200&q=80",
    ],
    highlights: [
      "Charter service with air-conditioned vehicle",
      "Ideal for groups and families",
      "Flexible pickup and dropoff across major Bali zones",
    ],
    bookingDetails: {
      terms: ["Free cancellation up to 24 hours", "Surcharge for remote areas may apply"],
      howToUse: ["Driver details shared one day before trip", "Show booking confirmation to driver"],
    },
    whatToExpect: {
      description: "Plan your own itinerary and travel at your own pace with a dedicated driver.",
      itinerary: ["Hotel pickup", "Custom sightseeing", "Hotel dropoff"],
      inclusions: ["Private vehicle", "Driver", "Fuel"],
      exclusions: ["Entrance fees", "Meals"],
      meetingPoint: "Pickup from hotel lobby",
    },
    operator: {
      name: "Island Mobility Bali",
      location: "Denpasar, Bali",
    },
    reviews: [{ user: "Mira", rating: 5, comment: "Very convenient and driver was professional." }],
    faqs: [
      { question: "Can I change my route on the day?", answer: "Yes, route is flexible within booked hours." },
    ],
    packages: [
      {
        name: "6 Hours Charter",
        skus: [
          {
            id: "bali-charter-6h",
            title: "6 Hours - City Area",
            price_adult: 45,
            price_child: 30,
            available_dates: ["2026-04-12", "2026-04-13", "2026-04-14"],
            capacity: 5,
          },
        ],
      },
      {
        name: "10 Hours Charter",
        skus: [
          {
            id: "bali-charter-10h",
            title: "10 Hours - Full Day",
            price_adult: 70,
            price_child: 45,
            available_dates: ["2026-04-13", "2026-04-15", "2026-04-18"],
            capacity: 5,
          },
        ],
      },
    ],
  },
  {
    id: "singapore-night-safari",
    title: "Singapore Night Safari Guided Experience",
    description: "Discover nocturnal wildlife with guided tram and walking trails.",
    category: "Experiences",
    location: "Singapore",
    country: "Singapore",
    rating: 4.6,
    purchaseCount: 3089,
    tags: ["Mobile voucher"],
    images: [
      "https://images.unsplash.com/photo-1546182990-dffeafbe841d?auto=format&fit=crop&w=1200&q=80",
    ],
    highlights: ["Guided tram ride", "Night wildlife encounters"],
    bookingDetails: {
      terms: ["Rescheduling allowed once"],
      howToUse: ["Redeem e-ticket at entrance"],
    },
    whatToExpect: {
      description: "Join a guided route through the park to see animals most active after dark.",
      itinerary: ["Entry", "Tram", "Walking trails"],
      inclusions: ["Admission", "Tram ride"],
      exclusions: ["Hotel transfer"],
      meetingPoint: "Night Safari entrance",
    },
    operator: { name: "Wildlife SG", location: "Mandai" },
    reviews: [],
    faqs: [],
    packages: [
      {
        name: "General",
        skus: [
          {
            id: "sg-night-safari-entry",
            title: "Entry + Tram",
            price_adult: 52,
            price_child: 38,
            available_dates: ["2026-04-12", "2026-04-14"],
            capacity: 0,
          },
        ],
      },
    ],
  },
];


const defaultOtherBookingQuestions = [
  {
    id: "hotel_pickup",
    question: "Do you need hotel pickup?",
    answer_type: "dropdown",
    options: ["Yes", "No"],
    required: true,
  },
  {
    id: "special_request",
    question: "Any dietary or accessibility requirements?",
    answer_type: "free_text",
    required: false,
  },
];

const toBookingSections = (listing) => {
  const sections = [
    {
      title: "What's Included",
      items: listing.whatToExpect?.inclusions || [],
      collapsible: true,
    },
    {
      title: "Meet up info",
      items: [listing.whatToExpect?.meetingPoint].filter(Boolean),
      collapsible: true,
    },
    {
      title: "Terms & conditions",
      items: listing.bookingDetails?.terms || [],
      collapsible: true,
    },
    {
      title: "How to use",
      items: listing.bookingDetails?.howToUse || [],
      collapsible: true,
    },
  ];

  if (listing.category === "Tours") {
    sections.unshift({
      title: "Itinerary",
      items: listing.whatToExpect?.itinerary || [],
      collapsible: true,
    });
  }

  if (listing.category === "Private Charter") {
    sections.push({
      title: "Max passenger / storage capacity",
      items: ["Up to 5 passengers", "Up to 3 medium luggage"],
      collapsible: true,
    });
  }

  return sections;
};

export const thingsToDoListings = rawThingsToDoListings.map((listing) => ({
  ...listing,
  serviceType: listing.category,
  operatorInfo: {
    name: listing.operator?.name,
    address: listing.operator?.location,
  },
  bookingSections: toBookingSections(listing),
  otherBookingQuestions: listing.otherBookingQuestions || defaultOtherBookingQuestions,
  packages: (listing.packages || []).map((pkg) => ({
    ...pkg,
    variation_title: pkg.name,
    skus: (pkg.skus || []).map((sku) => ({
      ...sku,
      ticket_type: sku.available_dates?.length ? "Scheduled" : "Open Dated",
      min_participants: listing.category === "Private Charter" ? null : 1,
      max_participants: listing.category === "Private Charter" ? null : sku.capacity,
    })),
  })),
}));

export const categories = ["Tours", "Experiences", "Attractions", "Private Charter"];

export const recommendations = thingsToDoListings.slice(0, 2);
